class PasswordDirective {
  static directive() {
    return {
      replace:true,
      scope: {
        model: '=',
        form: '=',
        autofocus: '=?'
      },
      template: `
        <md-input-container>
          <label for="password-input">{{ 'COMMONS.PASSWORD' | translate }} </label><!-- TODO -->
          <input id="password-input" ng-model="model" name="password" type="{{ passwordVisible ? 'text' : 'password' }}" ng-required="true" focus-if="autofocus">
          <md-button class="md-primary password-button" ng-click="passwordVisible = !passwordVisible"><i class="fa" ng-class="{'fa-eye': !passwordVisible, 'fa-eye-slash': passwordVisible}" aria-hidden="true"></i></md-button>
          <div ng-messages="form.password.$error" multiple md-auto-hide="false">
            <div ng-message="required">
              {{ 'COMMONS.PASSWORD_REQUIRED' | translate }}
            </div>
  
            <div ng-message="valid">
              {{ 'COMMONS.PASSWORD_WRONG' | translate }}
            </div>
          </div>
        </md-input-container>
      `
    }
  };
}

export default PasswordDirective.directive;


// WEBPACK FOOTER //
// ./src/users/directives/password.js